"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicFormFieldsValues = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const IsABAValidator_1 = require("../validators/IsABAValidator");
const IsBICValidator_1 = require("../validators/IsBICValidator");
const IsCompanyNumberValidator_1 = require("../validators/IsCompanyNumberValidator");
const IsIbanValidator_1 = require("../validators/IsIbanValidator");
const IsLatinValidator_1 = require("../validators/IsLatinValidator");
const IsVatNumberValidator_1 = require("../validators/IsVatNumberValidator");
let DynamicFormFieldsValues = class DynamicFormFieldsValues {
    documentId;
    cooperationAgreementSignedAs;
    email;
    businessName;
    firstName;
    lastName;
    birthdayAt;
    businessAddressStreet;
    businessAddressHouseNumber;
    businessAddressSuiteIdentifier;
    businessAddressFloorIdentifier;
    businessAddressDistrictName;
    businessAddressPOB;
    businessAddressZIP;
    businessAddressCity;
    headquartersAddressStreet;
    headquartersAddressHouseNumber;
    headquartersAddressSuiteIdentifier;
    headquartersAddressFloorIdentifier;
    headquartersAddressDistrictName;
    headquartersAddressPOB;
    headquartersAddressZIP;
    headquartersAddressCity;
    correspondenceAddressIsDifferentFromHqAddress;
    correspondenceAddressStreet;
    correspondenceAddressHouseNumber;
    correspondenceAddressSuiteIdentifier;
    correspondenceAddressFloorIdentifier;
    correspondenceAddressDistrictName;
    correspondenceAddressPOB;
    correspondenceAddressZIP;
    correspondenceAddressCity;
    bankAccountCountryId;
    bankAccountHolderName;
    nationalityCountryId;
    residenceCountryId;
    taxResidenceCountryId;
    companyIdNumber;
    taxIdentificationNumber;
    vatNumber;
    identifiedPersonNumber;
    occupation;
    uboDeclaration;
    invoiceCountryId;
    birthplace;
    birthplaceCity;
    birthplaceCountryId;
    basedIn;
    transportCountries;
    accountNumber;
    iban;
    abaRouting;
    bicSwift;
    permanentEstablishmentInAnotherCountry;
    permanentEstablishmentAddressStreet;
    permanentEstablishmentAddressHouseNumber;
    permanentEstablishmentAddressSuiteIdentifier;
    permanentEstablishmentAddressFloorIdentifier;
    permanentEstablishmentAddressDistrictName;
    permanentEstablishmentAddressPOB;
    permanentEstablishmentAddressZIP;
    permanentEstablishmentAddressCity;
    permanentEstablishmentCountryId;
};
exports.DynamicFormFieldsValues = DynamicFormFieldsValues;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "documentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "cooperationAgreementSignedAs", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsISO8601)({ strict: true }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "birthdayAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressStreet", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressHouseNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressSuiteIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressFloorIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressDistrictName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressPOB", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressZIP", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "businessAddressCity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressStreet", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressHouseNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressSuiteIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressFloorIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressDistrictName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressPOB", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressZIP", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "headquartersAddressCity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressIsDifferentFromHqAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressStreet", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressHouseNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressSuiteIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressFloorIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressDistrictName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressPOB", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressZIP", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "correspondenceAddressCity", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "bankAccountCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "bankAccountHolderName", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "nationalityCountryId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "residenceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "taxResidenceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(IsCompanyNumberValidator_1.IsCompanyNumberValidator),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.replace(/\s/g, "") : undefined)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "companyIdNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "taxIdentificationNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(IsVatNumberValidator_1.IsVatNumberValidator),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "vatNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "identifiedPersonNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "occupation", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "uboDeclaration", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "invoiceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
    // @deprecated
    ,
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "birthplace", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "birthplaceCity", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "birthplaceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "basedIn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "transportCountries", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "accountNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(IsIbanValidator_1.IsIbanValidator),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "iban", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.Validate)(IsABAValidator_1.IsABAValidator),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "abaRouting", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.Validate)(IsBICValidator_1.IsBICValidator),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "bicSwift", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentInAnotherCountry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressStreet", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressHouseNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressSuiteIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressFloorIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressDistrictName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressPOB", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressZIP", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, IsLatinValidator_1.IsLatin)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentAddressCity", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicFormFieldsValues.prototype, "permanentEstablishmentCountryId", void 0);
exports.DynamicFormFieldsValues = DynamicFormFieldsValues = __decorate([
    (0, class_transformer_1.Exclude)()
], DynamicFormFieldsValues);
//# sourceMappingURL=DynamicFormFieldsValues.js.map